module.exports = __webpack_public_path__ + "img/Group 10178.eaa4c869.svg";